var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { PageService } from '../../models/page.service';
import { MessageService } from '../../service/message.service';
import { ContentBaseComponent } from '../base/contentbase.component';
import { ButtonService } from './button.service';
var ButtonComponent = /** @class */ (function (_super) {
    __extends(ButtonComponent, _super);
    function ButtonComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.defMode = '';
        _this.buttons = [];
        return _this;
    }
    ButtonComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        if (this.component.params && this.component.params.mode) {
            this.defMode = this.component.params.mode;
        }
        this.setButtons(this.component);
    };
    ButtonComponent.prototype.setUnsubscribe = function () {
        this.eventSubscription.unsubscribe();
        this.refSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    ButtonComponent.prototype.setChangeCompData = function (component) {
        this.setButtons(component);
    };
    ButtonComponent.prototype.onEvent = function (e1, e2, rec) {
        this.action.firstAction(e2, { buttonType: e1 });
    };
    ButtonComponent.prototype.ngOnChanges = function (changes) {
        if (changes.component) {
            this.setButtons(this.component);
        }
    };
    ButtonComponent.prototype.setButtons = function (component) {
        this.buttons = (component.params && component.params.buttons ? component.params.buttons : []);
    };
    ButtonComponent.prototype.trackByButton = function (index, button) {
        return JSON.stringify(button);
    };
    ButtonComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'btn',
                    template: "<ul *ngIf=\"defMode === '' || defMode === mode\" id=\"{{ componentName }}\" [key]=\"'btn'\" buttonDir>\n  <li *ngFor=\"let button of buttons; trackBy: trackByButton\" [key]=\"'btn'\" [btn]=\"button\" buttonDir>\n    <item-btn [key]=\"'btn'\" [btn]=\"button\" (clickBtn)=\"onEvent(button.type, $event)\"></item-btn>\n  </li>\n</ul>\n"
                }] }
    ];
    /** @nocollapse */
    ButtonComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: ButtonService }
    ]; };
    return ButtonComponent;
}(ContentBaseComponent));
export { ButtonComponent };
//# sourceMappingURL=button.component.js.map